/*flag-options*/
/*--api----lt-back---url*/
/*--login----lt-back---url*/
/*--sso-team----lt-back---team*/
/*--manual*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "login",
  "description": "`turbo login` 命令的 API 参考"
};
export let structuredData = {
  "contents": [{
    "heading": "",
    "content": "登录你的远程缓存提供商。"
  }, {
    "heading": "",
    "content": "¥Log in to your Remote Cache provider."
  }, {
    "heading": "",
    "content": "默认提供程序是 Vercel。要指定其他提供程序，请使用 --api 选项。"
  }, {
    "heading": "",
    "content": "¥The default provider is Vercel. To specify a different provider, use the --api option."
  }, {
    "heading": "标志选项-flag-options",
    "content": "¥Flag options"
  }, {
    "heading": "--api-url---api----lt-back---url",
    "content": "设置远程缓存提供程序的 API URL。"
  }, {
    "heading": "--api-url---api----lt-back---url",
    "content": "¥Set the API URL of the Remote Cache provider."
  }, {
    "heading": "--login-url---login----lt-back---url",
    "content": "设置应动态生成令牌的登录请求的 URL。"
  }, {
    "heading": "--login-url---login----lt-back---url",
    "content": "¥Set the URL for login requests that should dynamically generate tokens."
  }, {
    "heading": "--sso-team-team---sso-team----lt-back---team",
    "content": "通过提供团队 slug 连接到启用单点登录 (SSO) 的团队。"
  }, {
    "heading": "--sso-team-team---sso-team----lt-back---team",
    "content": "¥Connect to an SSO-enabled team by providing your team slug."
  }, {
    "heading": "--manual---manual",
    "content": "手动输入令牌，而不是从登录服务请求令牌。"
  }, {
    "heading": "--manual---manual",
    "content": "¥Manually enter token instead of requesting one from a login service."
  }],
  "headings": [{
    "id": "标志选项-flag-options",
    "content": "标志选项 /*flag-options*/"
  }, {
    "id": "--api-url---api----lt-back---url",
    "content": "--api <url> /*--api----lt-back---url*/"
  }, {
    "id": "--login-url---login----lt-back---url",
    "content": "--login <url> /*--login----lt-back---url*/"
  }, {
    "id": "--sso-team-team---sso-team----lt-back---team",
    "content": "--sso-team <team> /*--sso-team----lt-back---team*/"
  }, {
    "id": "--manual---manual",
    "content": "--manual /*--manual*/"
  }]
};
export const toc = [{
  depth: 2,
  url: "#标志选项-flag-options",
  title: _jsx(_Fragment, {
    children: "标志选项 "
  })
}, {
  depth: 3,
  url: "#--api-url---api----lt-back---url",
  title: _jsx(_Fragment, {
    children: "--api <url> "
  })
}, {
  depth: 3,
  url: "#--login-url---login----lt-back---url",
  title: _jsx(_Fragment, {
    children: "--login <url> "
  })
}, {
  depth: 3,
  url: "#--sso-team-team---sso-team----lt-back---team",
  title: _jsx(_Fragment, {
    children: "--sso-team <team> "
  })
}, {
  depth: 3,
  url: "#--manual---manual",
  title: _jsx(_Fragment, {
    children: "--manual "
  })
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    h2: "h2",
    h3: "h3",
    p: "p",
    pre: "pre",
    span: "span",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx(_components.p, {
      children: "登录你的远程缓存提供商。"
    }), "\n", _jsx(_components.p, {
      children: "¥Log in to your Remote Cache provider."
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " login"
            })]
          })
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["默认提供程序是 ", _jsx(_components.a, {
        href: "https://vercel.com/",
        children: "Vercel"
      }), "。要指定其他提供程序，请使用 ", _jsx(_components.code, {
        children: "--api"
      }), " 选项。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥The default provider is ", _jsx(_components.a, {
        href: "https://vercel.com/",
        children: "Vercel"
      }), ". To specify a different provider, use the ", _jsx(_components.code, {
        children: "--api"
      }), " option."]
    }), "\n", _jsx(_components.h2, {
      id: "标志选项-flag-options",
      children: "标志选项 "
    }), "\n", _jsx(_components.p, {
      children: "¥Flag options"
    }), "\n", _jsx(_components.h3, {
      id: "--api-url---api----lt-back---url",
      children: "--api <url> "
    }), "\n", _jsx(_components.p, {
      children: "设置远程缓存提供程序的 API URL。"
    }), "\n", _jsx(_components.p, {
      children: "¥Set the API URL of the Remote Cache provider."
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " login"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --api=https://acme.com/api"
            })]
          })
        })
      })
    }), "\n", _jsx(_components.h3, {
      id: "--login-url---login----lt-back---url",
      children: "--login <url> "
    }), "\n", _jsx(_components.p, {
      children: "设置应动态生成令牌的登录请求的 URL。"
    }), "\n", _jsx(_components.p, {
      children: "¥Set the URL for login requests that should dynamically generate tokens."
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " login"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --login=https://acme.com"
            })]
          })
        })
      })
    }), "\n", _jsx(_components.h3, {
      id: "--sso-team-team---sso-team----lt-back---team",
      children: "--sso-team <team> "
    }), "\n", _jsx(_components.p, {
      children: "通过提供团队 slug 连接到启用单点登录 (SSO) 的团队。"
    }), "\n", _jsx(_components.p, {
      children: "¥Connect to an SSO-enabled team by providing your team slug."
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " login"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --sso-team=slug-for-team"
            })]
          })
        })
      })
    }), "\n", _jsx(_components.h3, {
      id: "--manual---manual",
      children: "--manual "
    }), "\n", _jsx(_components.p, {
      children: "手动输入令牌，而不是从登录服务请求令牌。"
    }), "\n", _jsx(_components.p, {
      children: "¥Manually enter token instead of requesting one from a login service."
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
